<div mat-dialog-title>
    Log

</div>
<div mat-dialog-content>
    login

</div>
<div mat-dialog-actions>
    <button mat-button (click)="close()"  >Cerrar</button>
</div>